/* eslint-disable no-shadow */
enum LocalStorageKeys {
  KEY_LOCAL_STORAGE_THEME = '@theme',
  ORDER_COLUMN_CONFIG = 'orderColumnConfig',
  ORDER_FILTERS = 'orderFilters',
  TENANT_ID = 'tenantId',
  AUTH_TYPE = 'authType',
}

export default LocalStorageKeys;
